import React, { ReactElement } from 'react';

import Status from 'components/Status';
import { Button } from 'components/Button';

import { classNames } from 'utils/css';
import Page from 'components/Page';
import styles from './FullPageError.module.scss';
import { TFullPageErrorProps } from './FullPageError.types';
import SafeAreaView from '../SafeAreaView';

function FullPageError({
  message,
  onClick,
  className,
  fullPage = false,
}: TFullPageErrorProps): ReactElement {
  const Parent = fullPage ? Page : React.Fragment;

  return (
    <SafeAreaView>
      <Parent>
        <div
          className={classNames(styles.wrapper, className && className)}
          data-testid="FullPageError">
          <Status
            type="error"
            title="Bir Hata Oluştu"
            description={
              message ||
              'Şu an isteğinizi gerçekleştiremiyoruz. Lütfen tekrar deneyiniz'
            }
          />
          {onClick && (
            <div className={styles.action}>
              <Button onClick={onClick} block>
                Tekrar Dene
              </Button>
            </div>
          )}
        </div>
      </Parent>
    </SafeAreaView>
  );
}

export { FullPageError };
